import React from 'react';

const PremiumIcon = () => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.35L13 7L8 9.65V4.35ZM10 1C7.47424 0.950847 4.94811 1.07782 2.44 1.38C2.18722 1.4509 1.95693 1.58564 1.77129 1.77129C1.58565 1.95693 1.4509 2.18722 1.38 2.44C1.11211 3.94492 0.984896 5.4715 1 7C0.984896 8.5285 1.11211 10.0551 1.38 11.56C1.4509 11.8128 1.58565 12.0431 1.77129 12.2287C1.95693 12.4144 2.18722 12.5491 2.44 12.62C4.94811 12.9222 7.47424 13.0492 10 13C12.5258 13.0492 15.0519 12.9222 17.56 12.62C17.8128 12.5491 18.0431 12.4144 18.2287 12.2287C18.4144 12.0431 18.5491 11.8128 18.62 11.56C18.8879 10.0551 19.0151 8.5285 19 7C19.0151 5.4715 18.8879 3.94492 18.62 2.44C18.5491 2.18722 18.4144 1.95693 18.2287 1.77129C18.0431 1.58564 17.8128 1.4509 17.56 1.38C15.0519 1.07782 12.5258 0.950847 10 1ZM10 0C10 0 16.25 8.9407e-08 17.81 0.42C18.2341 0.534356 18.6208 0.758008 18.9314 1.06861C19.242 1.37921 19.4656 1.76589 19.58 2.19C19.8696 3.77673 20.0103 5.38708 20 7C20.0103 8.61292 19.8696 10.2233 19.58 11.81C19.4656 12.2341 19.242 12.6208 18.9314 12.9314C18.6208 13.242 18.2341 13.4656 17.81 13.58C16.25 14 10 14 10 14C10 14 3.75 14 2.19 13.58C1.76589 13.4656 1.37922 13.242 1.06861 12.9314C0.758012 12.6208 0.53436 12.2341 0.420004 11.81C0.130362 10.2233 -0.0102501 8.61292 3.98082e-06 7C-0.0102501 5.38708 0.130362 3.77673 0.420004 2.19C0.53436 1.76589 0.758012 1.37921 1.06861 1.06861C1.37922 0.758008 1.76589 0.534356 2.19 0.42C3.75 8.9407e-08 10 0 10 0Z"
        fill="black"
      />
    </svg>
  );
};

export default PremiumIcon;
